import { IPageResponse } from '@/types/common.types';
import { axiosInstance } from '../axios-instance';
import {
  IChangeStudentParams,
  IChangeStudentPasswordParams,
  IMyStudent,
  IPaymentStatement,
  IPaymentStatementParams,
} from './types';
import { ILoginResponse } from '../auth/types';

export const getMyStudents = async (
  token?: string
): Promise<IPageResponse<IMyStudent>> => {
  const headers = token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};

  return axiosInstance.get('/parents/my-students', {
    headers,
  });
};

export const changeStudent = async (
  params: IChangeStudentParams
): Promise<ILoginResponse> => {
  return axiosInstance.put(
    '/parents/student',
    {
      studentID: params.studentID,
    },
    {
      headers: {
        Authorization: `Bearer ${params.token}`,
      },
      withCredentials: true,
    }
  );
};

export const updateStudentPassword = async (
  params: IChangeStudentPasswordParams
): Promise<void> => {
  return axiosInstance.put('/parents/student/change-password', params);
};

export const getPaymentStatement = async (
  params: IPaymentStatementParams
): Promise<IPageResponse<IPaymentStatement>> => {
  return axiosInstance.get('/accounting/overview', {
    params,
  });
};
